export default "__VITE_ASSET__DxkgZkgu__"